import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { t } from 'helpers/i18n';
import { UndefinedAble } from 'data/base';
import { AppVersion } from 'data/terra/AppVersion';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { success, error } from 'util/result';
import { AppSelectorState } from '../reducer';
import { Environment } from 'data/terra/Environment';
import { syncTerraPaymentIfNeeded } from './SyncTerraPayment';

export const ADD_APP_VERSION = 'ADD_APP_VERSION';

export interface AddAppVersionAction {
  type: typeof ADD_APP_VERSION;
  appVersion: AppVersion;
}

export const addAppVersion = (
  versionCode: string,
  sourceAppVersion: UndefinedAble<AppVersion>,
  defaultEnvironment: Environment
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  const selectedApp = getState().appSelector.selectedApp;
  let newVersion: UndefinedAble<AppVersion> = undefined;
  if (selectedApp) {
    const versionResult = await Terra.app.createAppVersion(
      selectedApp.id,
      versionCode,
      "",
      sourceAppVersion?.id,
      defaultEnvironment?.id,
    );
    if (versionResult.isSuccess()) {
      newVersion = versionResult.get()!.data;
      dispatch(syncTerraPaymentIfNeeded(newVersion));

      dispatch({
        type: ADD_APP_VERSION,
        appVersion: newVersion,
      } as AddAppVersionAction);
    } else {
      return error(versionResult.exception());
    }
    return success(newVersion);
  } else {
    return error(new Error(t('Please select app first')));
  }
};

export const addAppVersionDelegate: DelegateMapEntry<
  AddAppVersionAction,
  AppSelectorState
> = {
  [ADD_APP_VERSION]: (
    state: AppSelectorState,
    action: AddAppVersionAction
  ): AppSelectorState => {
    return {
      ...state,
      appVersions: [...state.appVersions, action.appVersion],
    };
  },
};
